import { Select, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ISelectOption } from '../../models/utils/selectOption'
import { defaultFilterOption } from '../../utils'
import { useGetDataOnScroll } from '../getDataOnScrollProps/useGetDataOnScrollProps'
import { getCookie } from 'typescript-cookie'
import { EntTerritorialsUnits } from '../../models/handBooks/territorialsUnits'
import { EntTerritorialUnitsFilter } from '../../models/filters/territorialUnitsFilter'
import { useLazyGetTerritorialUnitsListQuery } from '../../redux/api/handBooksApi/territorialUnitsApi'

interface IProps {
	value?: number | null
	type?: ('AREA' | 'REGION' | 'CITY_OF_REPUBLICAN_SIGNIFICANCE' | 'CITY_OF_REGIONAL_SIGNIFICANCE')[]
	onChange?: (value: number | string, option?: any) => void
	status?: any
	parentId?: number | null
	areaCode?: string | null
	placeholder?: string
}

const SelectTerritorialUnitsCode = (props: IProps) => {
	const { t } = useTranslation()
	const [options, setOptions] = useState<ISelectOption[]>([])
	const [isDropdownOpen, setIsDropdownOpen] = useState(false)

	const [getData] = useLazyGetTerritorialUnitsListQuery()
	const { fetching, data, setData, setFetching, setFilter, scrollHandler, setCurrentPage } =
		useGetDataOnScroll<EntTerritorialsUnits, EntTerritorialUnitsFilter>({
			initialFilter: new EntTerritorialUnitsFilter({
				type: props.type,
				parentId: props.parentId,
				areaCode: props.areaCode,
				id: props.value,
			}),
			query: getData,
		})

	useEffect(() => {
		const optionss = Array.from(new Set(data)).map(a => {
			return {
				label: getCookie('i18next') === 'ky' ? ` ${a.nameKy}` : ` ${a.nameRu}`,
				value: a.id ?? '',
				data: { id: a.id, code: a.code, polygonJson: a.polygonJson },
			}
		})
		setOptions(optionss)
	}, [data])

	useEffect(() => {
		if (!isDropdownOpen) return

		const filter = new EntTerritorialUnitsFilter()
		filter.type = props.type ?? null
		filter.parentId = props.parentId ?? null
		filter.areaCode = props.areaCode ?? null

		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}, [isDropdownOpen])

	const search = (value?: string) => {
		if (!value) return
		const filter = new EntTerritorialUnitsFilter()
		filter.name = value
		filter.type = props.type ?? null
		filter.parentId = props.parentId ?? null
		filter.areaCode = props.areaCode ?? null
		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}

	const clear = () => {
		const filter = new EntTerritorialUnitsFilter()
		filter.name = null
		filter.type = props.type ?? null
		filter.parentId = props.parentId ?? null
		filter.areaCode = props.areaCode ?? null

		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}

	return (
		<Select
			placeholder={props.placeholder || t('msg.selectPlaceholder')}
			onClear={clear}
			onSearch={search}
			onPopupScroll={scrollHandler}
			loading={fetching}
			value={props.value}
			onChange={props.onChange}
			options={options}
			status={props.status}
			filterOption={defaultFilterOption}
			showSearch
			style={{ width: '100%' }}
			allowClear
			onDropdownVisibleChange={setIsDropdownOpen}
			dropdownRender={menu => <Spin spinning={fetching}>{menu}</Spin>}
		/>
	)
}

export default SelectTerritorialUnitsCode
